<div *ngIf="type=='listingLoader'">
  <div class="skeleton-loader">
    <div class="row mb-3" *ngFor="let i of [0,1,2,3,4]">
      <div class="col-md-9">
        <div class="shimmer shimmer-bar w-75 mb-2" style="width: 75%;"></div>
      </div>
      <div class="col-md-3">
        <div class="shimmer shimmer-bar w-50 mb-2"></div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="type=='talenMovementLoader'">
  <div class="skeleton-loader p-3">
    <div class="row mb-3">
      <div class="col">
        <div class="shimmer shimmer-bar w-50 mb-2"></div>
        <div class="shimmer shimmer-bar w-50"></div>
      </div>
      <div class="col">
        <div class="shimmer shimmer-bar w-50 mb-2"></div>
        <div class="shimmer shimmer-bar w-50"></div>
      </div>
    </div>

    <div class="shimmer shimmer-box"></div>
  </div>

</div>

<div *ngIf="type == 'genderLoader'">
  <div class="skeleton-loader text-center p-3">
    <!-- Top rectangle (icon/image placeholder) -->
    <div class="shimmer shimmer-box mx-auto mb-3"></div>

    <!-- Bottom tags/labels/buttons -->
    <div class="d-flex justify-content-center gap-2">
      <div class="shimmer shimmer-pill w-25"></div>
      <div class="shimmer shimmer-pill w-25"></div>
    </div>
  </div>

</div>

<div *ngIf="type == 'ethnicityLoader'">
  <div class="skeleton-loader d-flex align-items-start gap-3 p-3">
    <!-- Left: Image or Icon -->
    <div class="shimmer shimmer-box"></div>

    <!-- Right: Lines of text -->
    <div class="flex-grow-1">
      <div class="shimmer shimmer-line w-75 mb-2"></div>
      <div class="shimmer shimmer-line w-50 mb-2"></div>
      <div class="shimmer shimmer-line w-60 mb-2"></div>
      <div class="shimmer shimmer-line w-40"></div>
    </div>
  </div>
</div>

<div *ngIf="type == 'companyLoader'">
  <div class="skeleton-loader p-3">
    <!-- Top: Avatar + header text -->
    <div class="d-flex align-items-start mb-3">
      <div class="shimmer shimmer-avatar me-3" style="height: 50px; border-radius: 50%; margin-right: 15px;"></div>
      <div class="flex-grow-1">
        <div class="shimmer shimmer-line w-50 mb-2"></div>
        <div class="shimmer shimmer-line w-25"></div>
      </div>
    </div>

    <!-- Full width title/summary -->
    <div class="shimmer shimmer-line w-100 mb-3"></div>

    <!-- Grid of pills/labels -->
    <div class="row mb-3">
      <div class="col-3" *ngFor="let i of [1,2,3,4,5,6]">
        <div class="shimmer shimmer-pill mb-2"></div>
      </div>
    </div>

    <!-- Paragraph lines -->
    <div *ngFor="let i of [1,2,3]" class="mb-2">
      <div class="shimmer shimmer-line w-100"></div>
    </div>

    <!-- Grid bottom pills again -->
    <div class="row">
      <div class="col-3" *ngFor="let i of [1,2,3,4,5,6]">
        <div class="shimmer shimmer-pill mb-2"></div>
      </div>
    </div>
  </div>

</div>

<div *ngIf="type=='keyProfesional'">
  <div class="skeleton-loader p-3">
    <div class="row mb-3">
      <div class="col">
        <div class="shimmer shimmer-bar w-50 mb-2"></div>
        <div class="shimmer shimmer-bar w-50"></div>
      </div>
      <div class="col">
        <div class="shimmer shimmer-bar w-50 mb-2"></div>
        <div class="shimmer shimmer-bar w-50"></div>
      </div>
    </div>
    <div></div>
